import SavingsElectricity from "./SavingsElectricity";
import SavingsGas from "./SavingsGas";

export default class Savings {
  branch: string;
  islas_peninsula: string;
  electricity: SavingsElectricity;
  gas: SavingsGas;
  otherServices: number;

  constructor(
    electricity: SavingsElectricity,
    gas: SavingsGas,
    otherServices: number
  ) {
    this.branch = "Electricidad";
    this.islas_peninsula = "Peninsula";
    this.electricity = electricity;
    this.gas = gas;
    this.otherServices = otherServices;
  }
}
